import React from 'react'
import { Divider } from 'antd'
import Logo from './logo'
import StoreButton from './other'
import { Link } from 'react-router-dom'
import { FaInstagram, FaXTwitter, FaFacebookF, FaLinkedinIn } from 'react-icons/fa6'

function Footer() {
  const products = [
    { key: "airtime-data", label: "Airtime & Data", path: "/products#airtime-data" },
    { key: "electricity-bill", label: "Electricity Bill", path: "/products#electricity-bill" },
    { key: "tv-subscription", label: "TV Subscription", path: "/products#tv-subscription" },
    { key: "invoice", label: "Invoice", path: "/products#invoice" },
    { key: "schedule-transfer", label: "Schedule Transfer", path: "/products#schedule-transfer" },
    { key: "more", label: "More", path: "/products", isHighlight: true },
  ]

  const socialLinks = [
    { key: "instagram", name: "Instagram", href: "https://instagram.com/paydatapp", Icon: FaInstagram },
    { key: "twitter", name: "X (Twitter)", href: "https://x.com/paydatapp", Icon: FaXTwitter },
    { key: "facebook", name: "Facebook", href: "https://facebook.com/paydatapp", Icon: FaFacebookF },
    { key: "linkedin", name: "LinkedIn", href: "https://linkedin.com/company/paydatapp", Icon: FaLinkedinIn },
  ]

  return (
    <div className='w-full min-h-[70vh] bg-wave bg-contain bg-no-repeat bg-bottom'>
      <div className='w-full md:w-[85%] lg:w-[80%] max-w-[1200px] mx-auto p-5 sm:p-10 md:p-20 xl:px-0 space-y-10'>
        <div className='w-full grid sm:grid-cols-2 md:grid-cols-5 gap-6 md:gap-8'>
          <div className='md:col-span-2 flex flex-col gap-5 md:gap-10'>
            <Logo black={true} imgClass='!w-[120px] md:!w-[150px]' />
            <StoreButton className='!grid-cols-1 !gap-3' imgClass='!w-[120px]' />
          </div>

          <div className='space-y-3'>
            <p className='text-lg font-bold'>Company</p>
            {[
              { key: "/about", label: "About Us" },
              { key: "/privacy-policy", label: "Privacy Policy" },
              { key: "/terms-&-conditions", label: "Terms & Conditions" },
              { key: "/faqs", label: "Resources" },
            ].map(({ key, label }) => <Link key={key} to={key} className='block text-sm font-normal text-[#1E1E1C] hover:text-[#515594] transition-colors'>{label}</Link>)}
          </div>

          <div className='space-y-3'>
            <p className='text-lg font-bold'>Products</p>
            {products.map(({ key, label, path, isHighlight }) => (
              <Link
                key={key}
                to={path}
                className={'block text-sm transition-colors '.concat(
                  isHighlight 
                    ? "!text-[#515594] font-bold hover:!text-[#414476] pt-1 inline-flex items-center gap-1 group" 
                    : "font-normal text-[#1E1E1C] hover:text-[#515594]"
                )}
              >
                {label}
                {isHighlight && <span className='group-hover:translate-x-1 transition-transform inline-block'>→</span>}
              </Link>
            ))}
          </div>

          <div className='space-y-3'>
            <p className='text-lg font-bold'>Get in touch</p>
            {[
              { key: "mailto:help@paydatapp.com", label: "help@paydatapp.com" },
              { key: "tel:+2347051627496", label: "(+234) 705 162 7496" },
            ].map(({ key, label }) => <Link key={key} to={key} className='block text-sm font-normal text-[#1E1E1C] hover:text-[#515594] transition-colors'>{label}</Link>)}
            <div className='flex items-center gap-2.5 pt-2'>
              {socialLinks.map(({ key, name, href, Icon }) => (
                <a
                  key={key}
                  href={href}
                  target='_blank'
                  rel='noopener noreferrer'
                  aria-label={name}
                  className='w-9 h-9 rounded-full bg-[#F3F4F6] text-[#333333] hover:bg-[#515594] hover:text-white flex items-center justify-center transition-all duration-200 hover:scale-105 shadow-sm'
                >
                  {Icon({ className: 'w-4 h-4' })}
                </a>
              ))}
            </div>
          </div>
        </div>

        <Divider className='bg-[#E7E7E7]' />

        <div className='space-y-5 text-[#1E1E1CA0] text-center'>
          <p className='text-xs md:text-sm font-normal'>
            PayDat is a digital wallet and bill payment platform. Banking services are provided by our partner, Providus Bank,<br className='hidden md:block' />
            a licensed financial institution regulated by the Central Bank of Nigeria.
          </p>
          <p className='text-xs md:text-sm font-normal'>
            All text, graphics, audio files, code, downloadable material, and other works on this website are the copyrighted works of Paydat. All Rights Reserved. <br className='hidden md:block' />
            Any unauthorized redistribution or reproduction of any copyrighted materials on this website is strictly prohibited. Other product and company <br className='hidden md:block' />
            names are trademarks of their respective owners.
          </p>
          <p className='text-xs md:text-sm font-normal'>Powered By Greenhabor Technologies Limited</p>
        </div>
      </div>
    </div>
  )
}

export default Footer